export const openSidebarWidth = 264;
export const closeSidebarWidth = 65;
export const headerDesktopHeight = 56;
export const invoiceHeaderDesktopHeight = 75;
export const filterMobileWith = 320;
export const masqueradingFooterHeight = 52;
